import styled from 'styled-components';

import { zindex } from 'utils/style/zindex';

import { sidebarBackgroundColor } from 'components/Sidebar/styles';
import { gray, black } from 'utils/style/colors';

export const Logo = styled.div`
  align-items: center;
  background-color: ${sidebarBackgroundColor};
  color: ${black};
  display: flex;
  flex-direction: column;
  height: 55px;
  justify-content: center;
  z-index: ${zindex.navigation};
  flex-wrap: nowrap;
  border-bottom: 0.2rem solid ${(props) => (props.collapsed ? gray : 'none')};
  margin: 1rem 2.5rem 0;
  //padding-bottom: 2rem;
  margin: ${(props) => props.collapsed && '0.5rem 0.25rem'};
  padding: ${(props) => props.collapsed && '0.5rem 0.25rem'};
  overflow: hidden;
  position: relative;
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  gap: 0.5rem;
`;

export const MoreAboutCompany = styled('div')`
  position: absolute;
  left: 1rem;
  top: 1rem;
`;

export const MoreAboutCompanyContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: var(--exact-white);
`;

export const LogoContent = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  height: 2rem;
  padding: 0 0.5rem;
  text-align: center;
  width: 12.5rem;
  font-weight: bolder;
  font-size: 1.1rem;
  white-space: nowrap;
`;

export const Unread = styled.span`
  color: var(--exact-white);
  padding: 0 6px 0 6px;
  font-size: 12px;
  font-weight: normal;
  margin-right: 40px;
  border-radius: 10px;
  background-color: #34c8b6;
`;

export const MessageContainer = styled('div')`
  margin: 1rem;
  padding: 1rem;
  border-radius: 25px;
  background-color: #dcdcdc;
`;

export const Circle = styled('span')`
  width: 2.6rem;
  height: 0.875rem;
  background: black;
  border-radius: 25px;
  background: linear-gradient(deeppink, orangered);
`;

export const LastMenuItemContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: 0.5rem 0;
`;
